import { lazy } from "react";

export const LazyUserListPage = lazy(async () => ({
    default: (await import("./UserListPage")).UserListPage
}));
